// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"214":"ed421591","833":"ed421591","976":"ed421591"}[chunkId] + ".chunk.css";
};